import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OverviewNewRoutingModule } from './overview-new-routing.module';
import { OverviewNewComponent } from './overview-new.component';
import { DxChartModule, DxTextAreaModule, DxRangeSelectorModule, DxDataGridModule, DxPopupModule, DxDateBoxModule, DxSwitchModule } from 'devextreme-angular';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { TopdownAdjustmentCommonModule } from 'src/app/widgets/topdown-adjustment-common/topdown-adjustment-common.component';
import { BookmarkModule } from 'src/app/widgets/bookmark/bookmark.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NextPreviousPopupModule } from 'src/app/widgets/next-previous-popup/next-previous-popup.module';
import { BookmarkNewComponent } from 'src/app/widgets/bookmark-new/bookmark-new.component';
import { FiltersGroupModule } from 'src/app/widgets/filters/filters-group/filters-group.module';
import { BookmarksControlsComponent } from 'src/app/widgets/bookmark-new/bookmarks-controls/bookmarks-controls.component';
import { HelpButtonComponent } from 'src/app/widgets/help-button/help-button.component';
import { DxTableControllerDirective } from 'src/app/directives/dx-table-controller.directive';
import { WebExportModule } from 'src/app/widgets/web-export/web.export.module';



@NgModule({
	declarations: [OverviewNewComponent],
	imports: [
		CommonModule,

		DxChartModule,
		DxTextAreaModule, DxRangeSelectorModule,
		DxDataGridModule,
		DevEpressCommonModule,
		DxPopupModule, DxDateBoxModule, FormsModule, ReactiveFormsModule,
		OverviewNewRoutingModule, TopdownAdjustmentCommonModule,
		BookmarkModule, DxSwitchModule, NextPreviousPopupModule,
		BookmarkNewComponent,
		FiltersGroupModule,
		BookmarksControlsComponent,
		HelpButtonComponent,
		DxTableControllerDirective,WebExportModule
	]
})
export class ForecastOverviewNewModule { }
